import React, { CSSProperties } from "react";

export interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  size?: CSSProperties["fontSize"];
  children: React.ReactElement<React.SVGProps<SVGSVGElement>>;
}

export const SvgIcon: React.FC<SvgIconProps> = ({ style, color, children, size, ...restProps }) => {
  return React.cloneElement(children, {
    style: { fontSize: size, color, ...style },
    ...restProps,
  });
};

SvgIcon.defaultProps = {
  size: "var(--icon-size)",
  width: "1em",
  height: "1em",
};
